import React from 'react'
import { Fab, Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import i18n from '../../locales/i18n'
import { Constant, Field } from '../../types'
import { getTranslatedFieldName } from '../../utils/languageUtils'
import ErrorTooltip from '../ErrorTooltip'

const useStyles = makeStyles(
  theme => ({
    button: {
      width: '100%',
      textTransform: 'none',
      boxShadow: 'none',
    },
    buttonInactive: {
      backgroundColor: theme.colors.badgeColor,
      border: theme.constants.inactiveBorder,
      color: theme.colors.sideText,
    },
    buttonError: {
      border: theme.constants.errorBorder,
    },
  }),
  { name: 'GenderField' },
)

export interface GenderFieldProps {
  readonly Gender: Constant[]
  readonly field: Field
  readonly required?: boolean
}

const GenderField = ({ Gender, field, required = false }: GenderFieldProps) => {
  const classes = useStyles()

  return (
    <ErrorTooltip
      message={i18n.t<string>('Tooltips:GENDER_IS_REQUIRED')}
      open={field.open && required}
      validateTag={field.validateTag}
    >
      <Grid container item spacing={3} wrap="nowrap">
        {Gender.map(gender => (
          <Grid item key={gender.id} md={6} xs={12}>
            <Fab
              className={classNames(classes.button, {
                [classes.buttonInactive]: field.value !== gender.id,
                [classes.buttonError]: !field.valid,
              })}
              type="button"
              variant="extended"
              onClick={() => field.setValue(gender.id)}
            >
              {getTranslatedFieldName(gender)}
            </Fab>
          </Grid>
        ))}
      </Grid>
    </ErrorTooltip>
  )
}

export default GenderField
